import { useNavigate } from 'react-router-dom';
import { client } from '../helpers/api-client';
import { createContext, useContext, useState, useEffect } from 'react';
import { ResponsiveLoadingPage } from '../screens/responsive-views';
import { resolveAuthToken, clearAuthCookies, TOKEN_SOURCE_KEY } from '../helpers/authToken';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const params = new URL(document.location).searchParams;
const partnerTicket = params.get('ticket');

export const AuthProvider = ({ children }) => {
  let navigate = useNavigate();
  const [userIsAuthenticated, setUserIsAuthenticated] = useState(null);

  useEffect(() => {
    if (partnerTicket) return partnerLogin(partnerTicket);
    // localStorage (legacy dashboard / ticket) first, then the new dashboard's cookies.
    if (!resolveAuthToken()) return (window.location.href = window.location.origin + '/login');
    return setUserIsAuthenticated(true);
  }, []);

  const partnerLogin = async (partnerTicket) => {
    try {
      const responseFromServer = await client(`api/ticket_system/ticket/validate/?ticket=${partnerTicket}`);
      const { room_name: serverRoomName, user_token: serverUserToken } = responseFromServer;

      if (window.location.pathname.includes(serverRoomName)) {
        localStorage.setItem('__ibis_token__', `{"token": ${JSON.stringify(serverUserToken)}}`);
        // Ticket token must win over any new-dashboard cookie on this browser.
        localStorage.removeItem(TOKEN_SOURCE_KEY);
        localStorage.setItem('room_name', serverRoomName);
        setUserIsAuthenticated(true);
        return navigate(`${process.env.PUBLIC_URL}/${serverRoomName}`);
      } else throw console.error();
    } catch {
      setUserIsAuthenticated(false);
      return navigate(`/error`, { state: { error: 'Sorry, there was a problem logging you in at this time.' } });
    }
  };

  const logout = () => {
    window.localStorage.clear();
    clearAuthCookies();
    return (window.location.href = window.location.origin + '/login');
  };

  return (
    <AuthContext.Provider
      value={{
        userIsAuthenticated,
        partnerLogin,
        logout,
      }}
    >
      {userIsAuthenticated !== null ? children : <ResponsiveLoadingPage />}
    </AuthContext.Provider>
  );
};
